import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Renderer from './Renderer'
import ScrollStopper from './ScrollStopper'
import Share from './Share'
import './App.css'

const isRunningStandalone = () => {
  return (
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
  )
}

class App extends Component {
  componentDidMount() {
    if (isRunningStandalone()) {
      document.body.classList.add('standalone')
    }
  }

  componentWillUnmount() {
    if (isRunningStandalone()) {
      document.body.classList.remove('standalone')
    }
  }

  render() {
    return (
      <Router>
        <div className="app">
          <ScrollStopper />
          <Switch>
            <Route exact path="/" component={Share} />
            <Route path="/preview/:appId" component={Renderer} />
            <Route path="/:appId" component={Share} />
          </Switch>
          <div className="app-border" />
        </div>
      </Router>
    )
  }
}

export default App
